// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import {
  BookHourlyCoachingFormCoachFragmentDoc,
  BookHourlyCoachingFormCoachingFocusFragmentDoc,
} from '../BookHourlyCoachingModal/__generated-gql-types__/BookHourlyCoachingForm.generated';
import {
  BookCoachingTimeFormCoachFragmentDoc,
  BookCoachingTimeFormCoachingFocusFragmentDoc,
} from '../BookHourlyCoachingModal/__generated-gql-types__/BookCoachingTimeForm.generated';
export type BookHourlyCoachingModalCoachFragment = {
  __typename?: 'Coach';
  id: string;
  hourlyRate?: number | null;
  tier: Types.SkuTier;
  user: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    pictureLink?: string | null;
  };
  mostRecentOrder?: {
    __typename?: 'Order';
    hourlyOrder?: { __typename?: 'HourlyOrder'; timeInMinute: number } | null;
  } | null;
};

export type BookHourlyCoachingModalCoachingFocusFragment = {
  __typename?: 'CoachingFocus';
  id: string;
  name: string;
};

export const BookHourlyCoachingModalCoachFragmentDoc = gql`
  fragment BookHourlyCoachingModal_Coach on Coach {
    ...BookHourlyCoachingForm_Coach
    ...BookCoachingTimeForm_Coach
  }
  ${BookHourlyCoachingFormCoachFragmentDoc}
  ${BookCoachingTimeFormCoachFragmentDoc}
`;
export const BookHourlyCoachingModalCoachingFocusFragmentDoc = gql`
  fragment BookHourlyCoachingModal_CoachingFocus on CoachingFocus {
    ...BookHourlyCoachingForm_CoachingFocus
    ...BookCoachingTimeForm_CoachingFocus
  }
  ${BookHourlyCoachingFormCoachingFocusFragmentDoc}
  ${BookCoachingTimeFormCoachingFocusFragmentDoc}
`;
